<template>
    <div class="monitoring-dynamics-item-circle">
        <CircleChart :current="data.processedWords" :max="data.totalWords" />
        <div class="monitoring-dynamics-item-circle__info">
            <p class="monitoring-dynamics-item-circle__value">
                <span>{{ data.processedWords }}</span> из <span>{{ data.totalWords }}</span>
            </p>
            <p class="monitoring-dynamics-item-circle__name">
                Обработано ключевых слов
            </p>
        </div>
    </div>
</template>

<script setup lang="ts">
    import type { MonitoringDynamicsItemCircleProps } from './types.ts'
    import CircleChart from '~/src/shared/components/ui/charts/CircleChart.vue'

    const props = defineProps<MonitoringDynamicsItemCircleProps>()

    const data = computed(() => {
        return {
            name: props.data.name,
            totalWords: props.data.totalWords,
            processedWords: props.data.processedWords
        }
    })
</script>

<style lang="scss" scoped>
    .monitoring-dynamics-item-circle {
        position: relative;
        display: flex;
        align-items: center;
        padding: 16px 26px;
        gap: 0 30px;

        &__value {
            margin-bottom: 8px;
            font-family: var(--accent-font);
            font-size: 24px;
            font-weight: 600;
            line-height: 1;
        }

        &__name {
            font-family: var(--accent-font);
            font-size: 12px;
            line-height: 1.2;
            color: var(--grey-400);
        }
    }
</style>
